import { render, staticRenderFns } from "./privilege-table.vue?vue&type=template&id=39ce0264&"
import script from "./privilege-table.vue?vue&type=script&lang=js&"
export * from "./privilege-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports